import styled from 'styled-components';

export default styled.h2`
    font-size: 1.5em;
    color: #2c3138;
`;